export const translationEN = {
    policyMessage: "By using FeedInApp you agree with our <Anchor>Privacy Policies</Anchor> that include the usage of cookies.",
    acceptButton: "I agree",
    loadingText: "FeedInApp®",
    loading: "Loading the menu...",
    noDescAvail: "No description available",
    vegetarianBadge: "Vegetarian",
    veganBadge: "Vegan",
    glutenFreeBadge: "Gluten Free",
    notGlutenFreeBadge: "Not Gluten Free",
    frozenBadge: "Frozen",
    closeModal: "Close",
    allergens: "Allergens:",
    contactUs: "Contact us",
    estimateCheck: "Estimate the check",
    priceModal: "Total: ",
    emptyCart: "Empty",
    cartPriceWarning: "*The specified price is just an estimate. It fails to take account of prices per kg or per liter and doesn't compute potential cover charges of the restaurant.",
    whenOpen: "When we're open",
    open: "Now open",
    closed: "Now closed",
    mon: "Monday",
    tue: "Tuesday",
    wed: 'Wednesday',
    thu: 'Thursday',
    fri: 'Friday',
    sat: 'Saturday',
    sun: 'Sunday',
    callUs: "Call us",
    website: "Website",
    ourEvents: "Our events",
    daysAgo: "days ago",
    hoursAgo: "hours ago",
    minutesAgo: "minutes ago",
    coverChargeIn: "Inside cover charge",
    coverChargeOut: "Outside cover charge",
    whoops: "whoops...",
    notFoundMsg: "We're sorry, we couldn't find what you were looking for.",
    review_us_modal_support_business: "Support our business",
    review_us_modal_headline: "REVIEW US ON GOOGLE",
    review_us_modal_subheadline: "Your opinion helps us reach much more people! Rate us if impressed by our products or service!",
    review_us_modal_button_text: "Review With Google",
    review_us_modal_greeting_text: "Make our day by leaving a 5 star review on",
    menu_modal_loading_text: "Loading image...",
    modal_wine_designations: "Designations:",
    modal_wine_gastronomic_matches: "Gastronomic Matches:",
    modal_wine_technicalities: "Technicalities:",
}